
export const Divider = () => {
	return (
		<div className="h-px bg-gray-800 mx-4 my-4"></div>
	)
}



